<template>
    <modal dialog="modal-m" class="dark-top" :header="false" :customClass="'heightAuto'" :footer="true">
        <div slot="body" class="p-4">

            <h2 class="text-center bold mb-3">Sales & Commissions Report</h2>

            <p class="mb-3">Please select one of the <span class="bold">available</span> reports:</p>

            <div class="row">
                <div class="col-sm-12 my-2">
                    <div class="col-8 pl-0" v-if="getYearsAndMonths.length > 0">
                        <v-select
                            label="referenceMonth"
                            v-model="selectedData"
                            placeholder="Report List"      
                            :options="getYearsAndMonths">
                        </v-select>
                    </div>

                    <div v-else class="w-100 text-center">
                        <loader />
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="pressDownload" :disabled="!selectedData || getIsDownloadingSupplierReport">Download</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Loader from '@/tools/loaders/loader1'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        data: function() {
            return {
                selectedData: null,
                monthNames: {
                    "01": "January",
                    "02": "February",
                    "03": "March",
                    "04": "April",
                    "05": "May",
                    "06": "June",
                    "07": "July",
                    "08": "August",
                    "09": "September",
                    "10": "October",
                    "11": "November",
                    "12": "December"
                }
            }
        },
        computed: {
            ...mapGetters([
                'getReportOptions',
                'getIsDownloadingSupplierReport'
            ]),
            reportOptions() {
                return this.getReportOptions
            },
            validateReportOptions() {
                return this.reportOptions < 0
            },
            getYearsAndMonths() {
                const reportOptions = this.reportOptions
                
                return reportOptions.sort((a, b) => b.referenceMonth.localeCompare(a.referenceMonth)).map(item => {
                    const referenceMonth = item.referenceMonth
                    const year = referenceMonth.slice(0, 4)
                    const month = referenceMonth.slice(4, 6)
                    const monthName = this.monthNames[month]

                    return {
                        ...item,
                        referenceMonth: `${year} - ${monthName}`
                    };
                });
            }
        },
        methods: {
            ...mapActions([
                'downloadSupplierReport',
                'closeModal',
            ]),
            cancel: function() {
                this.closeModal()
            },
            pressDownload: function() {
                this.downloadSupplierReport(this.selectedData).then(() => {
                    this.presentMessage({ 
                        title: 'Download successfully completed!',
                        subTitle: 'Your file is ready for use. You can find it in the "Downloads" section.'
                    })

                    this.closeModal()
                }).catch(() => {
                    this.presentMessage({ 
                        title: 'Something went wrong!',
                        subTitle: 'We apologize for the inconvenience! Please try again later.'
                    })

                    this.closeModal()
                })
            },
            presentMessage(info) {
                this.$dialog.alert(
                    `<div class="d-flex flex-column justify-content-center">
                        <div class="fs-largest font-weight-600 mb-4">${info.title}</div>
                        <div class="bold dark">${info.subTitle}</div>
                    </div>`,
                    { okText: 'Ok' })
            }
        },
        components: {
            Modal,
            Loader,
            vSelect: extendedVSelect,
        }
    }
</script>



// WEBPACK FOOTER //
// PrintReport.vue?10430c1e